import React from "react";
import "../../resources.css";
import { ResourceRoute } from "../../resource-routing";
import { Link } from "react-router-dom";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import ReactSEOMetaTags from "react-seo-meta-tags";
import Helmet from "react-helmet";
import RadioButtonsGroup from "../../../../components/common/radio-group";
import DatePickers from "../../../../components/common/date-range-picker";

import * as contactAction from "../../../../action/contactAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ROUTES } from "../../../../routes.js";
import moment from "moment";
import Slider from "../../../../components/slider";
import { withRouter } from "react-router-dom";

class NewsLetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterList: ["All", "Fintech", "Healthtech", "Web3", "Design"],
      pageEnabled: false,
      postedModal: false,
      postedAt: "",
      fromDate: moment(new Date()).format("YYYY-MM-DD"),
      toDate: moment(new Date()).format("YYYY-MM-DD"),
      dateErr: false,
      buttonShow: true,
      category: "All",
      start: 0,
      // end: 3,
      end: 12,
      //subscribe email
      email: "",
      emailErr: "",
      showMedia: false,
      freezeCard: false,
      cardList: props.cardData,
      filtercardList: props.filterData,
    };
    this.fromDateChange = this.fromDateChange.bind(this);
    this.toDateChange = this.toDateChange.bind(this);
    this.wrapperRef = React.createRef();
    this.postedAtClick = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cardList: nextProps.cardData,
      filtercardList: nextProps.filterData,
    });
    // {console.log('pageChange =1', nextProps.filterData)}
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.fromDate !== this.state.fromDate ||
        prevState.toDate !== this.state.toDate) &&
      this.state.fromDate <= this.state.toDate
    ) {
      let cardList = [...this.state.filtercardList];
      const filtercardList = cardList.filter((item) => {
        return (
          item?.category === this.state.category &&
          moment(item?.title).format("YYYY-MM-DD") >= this.state.fromDate &&
          moment(item?.title).format("YYYY-MM-DD") <= this.state.toDate
        );
      });
      this.setState({ cardList: filtercardList });
    }
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("scroll", this.subscribeDetail);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
  handleClickOutside(event) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target) &&
      this.postedAtClick.current &&
      !this.postedAtClick.current.contains(event.target)
    ) {
      this.setState({
        postedModal: false,
      });
    }
  }

  subscribeDetail = () => {
    if (document.getElementById("subscribe-float-btn")) {
      // console.log(windowTop, filterTop , 'asd')
      const windowTop = window.scrollY;
      const filterTop = document.getElementById(
        "subscribe-float-btn"
      ).offsetTop;
      if (windowTop > filterTop) {
        this.setState({ freezeCard: true });
      } else {
        this.setState({ freezeCard: false });
      }
    }
  };

  showSubscribe = () => {
    this.setState({ subscribeNow: true });
  };

  pushToRoute = (val) => {
    this.props.history.push(val);
  };
  viewMoreOnPress = () => {
    let arrLength = this.state.cardList.length;
    let remainder = this.state.cardList.slice(this.state.end, arrLength).length;
    this.setState(
      {
        buttonShow: !this.state.buttonShow,
      },
      () => {
        if (this.state.buttonShow) {
          this.setState({
            end: 3,
          });
          window.scrollTo(0, 0);
        } else {
          this.setState({
            end: this.state.end + remainder,
          });
        }
      }
    );
  };

  categoryPress = (category) => {
    this.setState({ category: category });
    let cardList = [...this.state.filtercardList];
    const filtercardList = cardList?.filter((item) =>
      category === "All" ? item : category === item?.category
    );
    this.setState({ cardList: filtercardList });
    this.props.onChange(filtercardList);
    if (this.state.postedModal) {
      this.setState({
        postedModal: !this.state.postedModal,
      });
    }
    this.setState({ postedAt: "" });
  };
  postedAt = () => {
    this.setState({
      postedModal: !this.state.postedModal,
    });
  };
  postedValueChange = (value) => {
    this.setState({ postedAt: value });
    let cardList = [...this.state.filtercardList];
    console.log("cardList", cardList);
    if (value === "Today") {
      const filtercardList = cardList.filter((item) => {
        return (
          item?.category === this.state.category &&
          moment(item?.title).format("YYYY-MM-DD") ===
            moment(Date.now()).format("YYYY-MM-DD")
        );
      });
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "Thismonth") {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const filtercardList = cardList.filter((item) => {
        if (this.state.category === "All") {
          return (
            new Date(item?.title?.toString()?.trim()).getMonth() + 1 ===
              currentMonth &&
            new Date(item?.title?.toString()?.trim()).getFullYear() ===
              currentYear
          );
        } else {
          return (
            item?.category === this.state.category &&
            new Date(item?.title?.toString()?.trim()).getMonth() + 1 ===
              currentMonth &&
            new Date(item?.title?.toString()?.trim()).getFullYear() ===
              currentYear
          );
        }
      });
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "Thisweek") {
      var currentDate = moment();
      const filtercardList = cardList.filter((item) => {
        if (this.state.category === "All") {
          return moment(item?.title?.toString()?.trim()).isSame(
            currentDate,
            "week"
          );
        } else {
          return (
            item?.category === this.state.category &&
            moment(item?.title?.toString()?.trim()).isSame(currentDate, "week")
          );
        }
      });
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "Thisyear") {
      const currentYear = new Date().getFullYear();
      console.log(currentYear, "currentYear", this.state.category, cardList);
      const filtercardList = cardList.filter((item) => {
        if (this.state.category === "All") {
          return (
            new Date(item?.title?.toString()?.trim()).getFullYear() ===
            currentYear
          );
        } else {
          return (
            item?.category === this.state.category &&
            new Date(item?.title?.toString()?.trim()).getFullYear() ===
              currentYear
          );
        }
      });
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "Setup") {
      const filtercardList = cardList.filter((item) => {
        return (
          item?.category === this.state.category &&
          moment(item?.title).format("YYYY-MM-DD") >= this.state.fromDate &&
          moment(item?.title).format("YYYY-MM-DD") <= this.state.toDate
        );
      });
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "") {
      const filtercardList = cardList.filter(
        (item) => item?.category === this.state.category
      );
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
    if (value === "" && this.state.category === "All") {
      const filtercardList = cardList.filter((item) => item);
      this.setState({ cardList: filtercardList });
      this.props.onChange(filtercardList);
    }
  };

  handleChange(e) {
    var val = e.target.value;
    val = val.replace(/^\s+/, "");
    this.setState({
      email: val,
    });
  }
  fromDateChange(e) {
    this.setState({
      dateErr: false,
    });
    this.setState(
      {
        fromDate: e,
      },
      () => {
        if (this.state.fromDate > this.state.toDate) {
          this.setState({
            dateErr: true,
          });
        }
      }
    );
  }
  toDateChange(e) {
    this.setState({
      dateErr: false,
    });
    this.setState(
      {
        toDate: e,
      },
      () => {
        if (this.state.fromDate > this.state.toDate) {
          this.setState({
            dateErr: true,
          });
        }
      }
    );
  }

  render() {
    let placeholderText = `Stay inspired with our ${this.state.category} newsletter`;
    var settings = {
      // className: "center",
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      centerMode: true,
      // speed:8000,
      // autoplaySpeed: 12000,
      speed: 2000,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1098,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <>
        <Helmet>
          <title>Newsletter | Ionixx Technologies</title>
          <meta
            name="description"
            content="Ix Digest is a weekly tech newsletter featuring technology,blockchain news, and other interesting tech insights."
          />
          <link
            rel="canonical"
            href="https://www.ionixxtech.com/resources/newsletter"
          />
          {/* <meta
            property="og:title"
            content=" Newsletter | Ionixx Technologies"
          /> */}
          {/* <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.ionixxtech.com/resources/newsletter" />
            <meta property="og:image" content="https://www.ionixxtech.com/assets/img/SEO_OG_IMAGE/newsletter.png" />               */}
          {/* <meta property="og:image:width" content="600" />
            <meta property="og:image:height" content="400" /> */}
          {/* <meta property="og:site_name" content="Ionixx Technologies" />
            <meta property="og:description" content="Ix Digest is a weekly tech newsletter featuring technology,blockchain news, and other interesting tech insights." /> */}
          {/* <meta name="twitter:card" content="summary_large_image">
            <meta name="twitter:site" content="https://www.ionixxtech.com/resources/newsletter"/>
            <meta name="twitter:title" content="Newsletter | Ionixx Technologies" />
            <meta name="twitter:description" content="Ix Digest is a weekly tech newsletter featuring technology,blockchain news, and other interesting tech insights." />
            <meta name="twitter:image" content="image url path" />
            <meta itemprop="image" content="image url path" /> */}
        </Helmet>
        <ReactSEOMetaTags
          render={(el) => <Helmet>{el}</Helmet>}
          website={{
            name: "Ionixx Technologies",
            title: "Newsletter | Ionixx Technologies",
            description:
              "Ix Digest is a weekly tech newsletter featuring technology,blockchain news, and other interesting tech insights.",
            type: "website",
            image: "/assets/img/SEO_OG_IMAGE/newsletter.png",
            url: "https://www.ionixxtech.com/resources/newsletter",
          }}
          twitter={{
            twitter: "https://www.ionixxtech.com/resources/newsletter",
          }}
        />
        <div className="Resources">
          <div className="blog-content newsletter-content">
            <div className="newsletter-common">
              <div className="main-head-div">
                {/* <h4 className="main-head-1">
                  <span className="primary-span">Newsletter</span>
                </h4>
                <h6 className="cate-head">Pick a Category</h6> */}

                {/* <p className="press-info">Weekly tech dose and other fascinating insights curated by Ionixx Technologies</p> */}
              </div>

              {/* {this.state.emailErr.length > 0 ? <div className="err-msg">{this.state.emailErr}</div>: ""} */}
              <div className="tech-nexus">
                <h4>Ionixx Tech Nexus</h4>
              </div>
              <div className="featured-articles">
                <h1 className="mb-5">Featured Articles</h1>
                <Slider {...settings}>
                  <div className="featured-article-wrap">
                    <div className="featured-left">
                      <Link to={ResourceRoute.NEWSISSUE82}>
                        <img
                          src="/assets/img/resource/thumbnail.svg"
                          alt="thumbnail"
                        />
                      </Link>
                    </div>
                    <div className="featured-right">
                      <ul className="category-list">
                        <li>HealthTech</li>
                        {/* <li>Design Studio</li> */}
                      </ul>
                      <Link to={ResourceRoute.NEWSISSUE82}>
                        <b>
                          The Role of Machine Learning in Medical
                          Decision-Making
                        </b>
                      </Link>
                      <em>22 June 2023</em>
                      <p>
                        Understanding the foundations of AI and its subfields,
                        Machine Learning (ML) and Deep Learning (DL), is crucial
                        for appreciating their impact on medical
                        decision-making.{" "}
                      </p>
                    </div>
                  </div>
                  {/* <div className="featured-article-wrap">
                  <div className="featured-left">
                    <img
                      src="/assets/img/resource/thumbnail.svg"
                      alt="thumbnail"
                    />
                  </div>
                  <div className="featured-right">
                    <ul className="category-list">
                      <li>Fintech</li>
                      <li>Design Studio</li>
                    </ul>
                    <b>
                      Healthcare Providers Continue to Adapt to Changing Care
                      Environments
                    </b>
                    <em>April 11, 2023</em>
                    <p>
                      The bitcoin price has rocketed over the first three months
                      of 2023, adding around 70% and helping the ethereum price
                      and other smaller cryptocurrencies soar ahead{" "}
                    </p>
                  </div>
                </div> */}
                </Slider>
                {/* <div className="featured-arrow">
                  <span className="left-arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="41"
                      height="41"
                      viewBox="0 0 41 41"
                      fill="none"
                    >
                      <rect
                        x="1"
                        y="0.890137"
                        width="39"
                        height="39"
                        rx="19.5"
                        fill="white"
                      />
                      <path
                        d="M24.0542 13.2802C23.3599 12.5858 22.2342 12.5859 21.5399 13.2802L14.4314 20.3897L21.5399 27.4992C22.2342 28.1936 23.3599 28.1936 24.0542 27.4993C24.7485 26.8049 24.7484 25.6792 24.0541 24.985L19.4579 20.3897L24.0541 15.7944C24.7484 15.1002 24.7485 13.9745 24.0542 13.2802Z"
                        fill="#007CC1"
                      />
                      <rect
                        x="1"
                        y="0.890137"
                        width="39"
                        height="39"
                        rx="19.5"
                        stroke="#007CC1"
                      />
                    </svg>
                  </span>
                  <span className="right-arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="41"
                      height="41"
                      viewBox="0 0 41 41"
                      fill="none"
                    >
                      <rect
                        x="1"
                        y="0.890137"
                        width="39"
                        height="39"
                        rx="19.5"
                        fill="white"
                      />
                      <path
                        d="M24.0542 13.2802C23.3599 12.5858 22.2342 12.5859 21.5399 13.2802L14.4314 20.3897L21.5399 27.4992C22.2342 28.1936 23.3599 28.1936 24.0542 27.4993C24.7485 26.8049 24.7484 25.6792 24.0541 24.985L19.4579 20.3897L24.0541 15.7944C24.7484 15.1002 24.7485 13.9745 24.0542 13.2802Z"
                        fill="#007CC1"
                      />
                      <rect
                        x="1"
                        y="0.890137"
                        width="39"
                        height="39"
                        rx="19.5"
                        stroke="#007CC1"
                      />
                    </svg>
                  </span>
                </div> */}
              </div>
              <div className="category-wrap" id="subscribe-float-btn">
                <div className="filter-wrap">
                  <div className="category-filter">
                    <ul className="category-list">
                      {this.state.filterList.map((item) => {
                        return (
                          <li
                            style={{
                              backgroundColor:
                                this.state.category === item ? "#007CC1" : "",
                              color:
                                this.state.category === item ? "#ffffff" : "",
                            }}
                            onClick={this.categoryPress.bind(this, item)}
                          >
                            {" "}
                            {item}
                          </li>
                        );
                      })}
                      <li ref={this.postedAtClick}>
                        <span onClick={this.postedAt}>
                          <i>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_86_6966)">
                                <path
                                  d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
                                  fill="#007CC1"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_86_6966">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </i>
                          Posted at
                          <em>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none"
                            >
                              <path
                                d="M0.25 0.5L4 4.25L7.75 0.5H0.25Z"
                                fill="#007CC1"
                              />
                            </svg>
                          </em>
                        </span>
                        {this.state.postedModal && (
                          <RadioButtonsGroup
                            postedValueChange={this.postedValueChange}
                            postedAt={this.state.postedAt}
                            ref={this.wrapperRef}
                          />
                        )}
                        {this.state.postedAt === "Setup" && (
                          <div className="datepicker">
                            <DatePickers
                              label="From Date"
                              onChange={this.fromDateChange}
                              defaultValue={this.state.fromDate}
                            />
                            <DatePickers
                              label="To Date"
                              onChange={this.toDateChange}
                              defaultValue={this.state.toDate}
                            />
                          </div>
                        )}
                        {this.state.dateErr && (
                          <p>{"choose the valid state"}</p>
                        )}
                      </li>
                    </ul>

                    {/* posted at modal */}
                    {/* {this.state.postedModal && (
                    <RadioButtonsGroup
                      postedValueChange={this.postedValueChange}
                      postedAt={this.state.postedAt}
                    />
                  )} */}
                  </div>
                  <div className="subscribe-float">
                    <div
                      className={
                        this.state.freezeCard
                          ? "subscribe-hover sticky"
                          : "subscribe-hover"
                      }
                    >
                      <input
                        type="text"
                        placeholder={placeholderText}
                        name={"email"}
                        value={this.state.email}
                        onChange={this.handleChange.bind(this)}
                      />
                      <button
                        onClick={() => {
                          var emailRegx =
                            /^(([a-zA-Z\d-_.]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                              this.state.email
                            );
                          if (emailRegx === false) {
                            this.setState({
                              emailErr: "Invalid Email",
                            });
                          } else {
                            this.props
                              .subscribeForNewsLetter({
                                emailID: this.state.email,
                                name: "",
                                category: this.state.category,
                                url: "",
                              })
                              .then((res) => {})
                              .catch((err) => {
                                console.log(err);
                              });
                            this.props
                              .sendNewsFeed(this.state.email)
                              .then((res) => {
                                this.setState({
                                  email: "",
                                  emailErr: "",
                                });
                                if (res.status === 200) {
                                  this.props.history.push({
                                    pathname: ROUTES.SUBSCRIBE,
                                    contactDetails: false,
                                    subscribeDetails: true,
                                    pdfDownload: false,
                                  });
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }
                        }}
                      >
                        Subscribe{" "}
                      </button>{" "}
                    </div>

                    {/* {this.state.subscribeNow && <div className='subscribe-our-news'>
                                        <div className="form-group newsletter-form-group">
                                            <input type="text" className="form-control" id="" placeholder="Enter your email*" name={"email"} value={this.state.email} onChange={this.handleChange.bind(this)}></input>
                                            <div className="newsletter-arrow" onClick={() => {
                                                var emailRegx = /^(([a-zA-Z\d-_.]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email);
                                                if (emailRegx === false) {
                                                    this.setState({
                                                        emailErr: "Invalid Email"
                                                    })
                                                }
                                                else {
                                                    this.props.sendNewsFeed(this.state.email).then((res) => {
                                                        this.setState({
                                                            email: "",
                                                            emailErr: ""
                                                        })
                                                        if (res.status === 200) {
                                                            this.props.history.push({
                                                                pathname: ROUTES.TOAST,
                                                                contactDetails: false,
                                                                subscribeDetails: true,
                                                                pdfDownload: false
                                                            })
                                                        }

                                                    }).catch((err) => {
                                                        console.log(err)
                                                    })
                                                }
                                            }}>
                                                <button>
                                                    <img src="/assets/newsletter_images/right-arrow.svg" />
                                                </button>
                                            </div>
                                        </div>
                                        

                                    </div>} */}
                    {this.state.emailErr.length > 0 ? (
                      <div className="err-msg">
                        <span>{this.state.emailErr}</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="tab-card porti-card news-card">
                  {this.state.cardList?.length > 0 ? (
                    this.state.cardList
                      ?.slice(this.state.start, this.state.end)
                      ?.map((item, i) => {
                        return (
                          <div className="list-card">
                            <div className="list-card-inner">
                              <Link to={item.Link}>
                                <strong className="number-bg">
                                  {item?.issue.slice(10)}
                                </strong>
                                <em
                                  className={
                                    item?.category === "Web3"
                                      ? "pink"
                                      : item?.category === "Fintech"
                                      ? "blue"
                                      : item?.category === "Design"
                                      ? "orange"
                                      : item?.category === "Healthtech"
                                      ? "green"
                                      : ""
                                  }
                                >
                                  {item?.category}
                                </em>
                                <b>
                                  {item?.content1.substring(0, 75) + " ... "}
                                </b>
                                <span>Read More</span>
                              </Link>
                            </div>
                            <strong>
                              <span>{item?.title},</span> {item?.issue}
                            </strong>
                            <i className="download">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_2_3821)">
                                  <rect
                                    width="30"
                                    height="30"
                                    rx="15"
                                    fill="#123245"
                                  />
                                  <circle
                                    cx="50"
                                    cy="50"
                                    r="49.9"
                                    stroke="#FF0000"
                                    stroke-opacity="0.1"
                                    stroke-width="0.2"
                                  />
                                  <circle
                                    cx="50"
                                    cy="50"
                                    r="29.9"
                                    stroke="#FF0000"
                                    stroke-opacity="0.1"
                                    stroke-width="0.2"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M17.2619 6.00338C18.4309 6.74711 19.2937 7.88601 19.6933 9.21261C20.3439 9.19648 20.9912 9.30865 21.5984 9.5427C22.2056 9.77675 22.7607 10.1281 23.2321 10.5767C23.7036 11.0253 24.082 11.5623 24.3458 12.1572C24.6097 12.752 24.7538 13.393 24.7699 14.0436C24.786 14.6941 24.6739 15.3415 24.4398 15.9486C24.2058 16.5558 23.8544 17.111 23.4058 17.5824C22.9572 18.0538 22.4202 18.4322 21.8253 18.6961C21.2305 18.9599 20.5895 19.104 19.939 19.1202H18.2877C18.0687 19.1202 17.8587 19.0332 17.7039 18.8783C17.5491 18.7235 17.4621 18.5135 17.4621 18.2945C17.4621 18.0756 17.5491 17.8656 17.7039 17.7107C17.8587 17.5559 18.0687 17.4689 18.2877 17.4689H19.939C20.8148 17.4689 21.6548 17.121 22.2742 16.5016C22.8935 15.8823 23.2415 15.0423 23.2415 14.1664C23.2415 13.2905 22.8935 12.4505 22.2742 11.8312C21.6548 11.2118 20.8148 10.8639 19.939 10.8639C19.7011 10.8627 19.4637 10.8869 19.231 10.9361C19.1205 10.9602 19.0062 10.9614 18.8952 10.9395C18.7842 10.9177 18.6789 10.8732 18.5858 10.809C18.4927 10.7447 18.4138 10.662 18.354 10.566C18.2942 10.47 18.2548 10.3627 18.2382 10.2508C18.1777 9.6946 18.0048 9.15647 17.7299 8.66912C17.4551 8.18177 17.084 7.75538 16.6393 7.41584C16.1946 7.07631 15.6855 6.83073 15.1429 6.69401C14.6004 6.55729 14.0357 6.53228 13.4832 6.62052C12.9307 6.70875 12.4019 6.90838 11.9289 7.20728C11.4559 7.50617 11.0486 7.8981 10.7318 8.35925C10.4149 8.8204 10.1951 9.34115 10.0857 9.88986C9.97634 10.4386 9.97963 11.0038 10.0954 11.5512C10.1155 11.6706 10.1091 11.793 10.0766 11.9096C10.0442 12.0262 9.98645 12.1343 9.90757 12.2262C9.82617 12.3153 9.72745 12.3869 9.61743 12.4366C9.50741 12.4863 9.38841 12.513 9.26771 12.5151H9.16657C8.50966 12.5203 7.88172 12.7863 7.42089 13.2545C6.96006 13.7226 6.70409 14.3547 6.70929 15.0116C6.71449 15.6685 6.98044 16.2965 7.44862 16.7573C7.9168 17.2181 8.54888 17.4741 9.20579 17.4689H11.6827C11.9016 17.4689 12.1116 17.5559 12.2665 17.7107C12.4213 17.8656 12.5083 18.0756 12.5083 18.2945C12.5083 18.5135 12.4213 18.7235 12.2665 18.8783C12.1116 19.0332 11.9016 19.1202 11.6827 19.1202H9.20579C8.18205 19.1212 7.19445 18.7418 6.4347 18.0556C5.67496 17.3694 5.19728 16.4254 5.0944 15.4069C4.99151 14.3883 5.27076 13.3679 5.87794 12.5436C6.48511 11.7194 7.37689 11.1502 8.38016 10.9464V10.8639C8.38391 9.4784 8.88525 8.14038 9.79284 7.09356C10.7004 6.04675 11.9539 5.36081 13.3248 5.16071C14.6958 4.9606 16.093 5.25966 17.2619 6.00338ZM14.4015 14.4074C14.5563 14.2525 14.7663 14.1655 14.9853 14.1655C15.2042 14.1655 15.4142 14.2525 15.5691 14.4074C15.7239 14.5622 15.8109 14.7722 15.8109 14.9912V22.0792L16.878 21.0121C17.0329 20.8571 17.2431 20.7701 17.4621 20.7701C17.6812 20.7701 17.8914 20.8571 18.0463 21.0121C18.2012 21.167 18.2882 21.3771 18.2882 21.5962C18.2882 21.8153 18.2012 22.0254 18.0463 22.1803L15.5694 24.6572C15.4927 24.734 15.4017 24.7949 15.3014 24.8364C15.2012 24.878 15.0938 24.8994 14.9853 24.8994C14.8768 24.8994 14.7693 24.878 14.6691 24.8364C14.5689 24.7949 14.4778 24.734 14.4011 24.6572L11.9242 22.1803C11.7693 22.0254 11.6823 21.8153 11.6823 21.5962C11.6823 21.3771 11.7693 21.167 11.9242 21.0121C12.0792 20.8571 12.2893 20.7701 12.5084 20.7701C12.7275 20.7701 12.9376 20.8571 13.0925 21.0121L14.1596 22.0792V14.9912C14.1596 14.7722 14.2466 14.5622 14.4015 14.4074Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2_3821">
                                    <rect
                                      width="30"
                                      height="30"
                                      rx="15"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </i>
                          </div>
                        );
                      })
                  ) : (
                    <div className="text-center no-data">No records found</div>
                  )}

                  {/* <div className='view-more-action'>
                    {
                     
                      this.state.cardList?.length > 12 && this.state.buttonShow ? (
                        <span onClick={this.viewMoreOnPress}>View More {">>"}</span>
                      ) : (
                        ""
                      )
                    }
                  </div> */}

                  {/* {
                                        this.state.cardList.length > 0 ? this.state.cardList.slice(this.state.start, this.state.end)?.map((item, i)=>{
                                            return (
                                                <div className="list" key={i}>
                                                <div className="list-capt">
                                            <h4><span>{item.content1}</span></h4>
                                                    <p>{item.content2}</p>
                                                    <p className="newsletter-publish-info"><span>{item.title} </span><span>{item.issue}</span></p>
                                                </div>
                                                <div className="download-btn" onClick={()=>{this.pushToRoute(item.Link)}}>
                                                </div>
                                            </div>
                                            )
                                        }) : 
                                        <div className="text-center no-data">No data found</div>
                                    }
                                    {
                                   {this.state.cardList.length > 12 && this.state.buttonShow ?  "View More" : "View Less" }
                                        <span><img className={!this.state.buttonShow ?"rotate-view-more": "" }src="/assets/img/blue-arrow.svg" alt="arrow"/></span>
                                      this.state.cardList.length > 12 && this.state.buttonShow === true? <div className="view-more">
                                    <button onClick={this.viewMoreOnPress} >
                                   </button>
                                </div>  : ""
                                }    
                                </div> 

                
                 
                                {
                                    this.state.cardList.length > 12 && this.state.buttonShow === false? <div className="view-more">
                                    <button onClick={this.viewMoreOnPress} >
                                    <span><img className={!this.state.buttonShow ?"rotate-view-more mt-0 mb-0": "" }src="/assets/img/blue-arrow.svg"  alt="arrow"/></span>
                                    {this.state.cardList.length > 12 && this.state.buttonShow ?  "View More" : "View Less" }
                                    </button>
                                </div>  : ""
                                }      */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return state.commonReducer;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(contactAction, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewsLetter));
